// dev_lp i18n — ISOLATED i18next instance (scoped to the new dev landing page only).
// Uses createInstance() so it never touches global i18n state or the rest of the app.

import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import he from "./locales/he.json";
import en from "./locales/en.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import ptBR from "./locales/pt-BR.json";
import fr from "./locales/fr.json";
import ru from "./locales/ru.json";

import { DEV_LP_DEFAULT_LANG } from "./languages";

export const devLpI18n = createInstance();

devLpI18n.use(initReactI18next).init({
  resources: {
    he: { translation: he },
    en: { translation: en },
    it: { translation: it },
    de: { translation: de },
    ja: { translation: ja },
    es: { translation: es },
    ar: { translation: ar },
    "pt-BR": { translation: ptBR },
    fr: { translation: fr },
    ru: { translation: ru },
  },
  lng: DEV_LP_DEFAULT_LANG,
  fallbackLng: "he",
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false,
  },
});

export default devLpI18n;
